import { Container, Stack, Typography, Card, CardContent, Alert, CircularProgress } from "@mui/material";
import ReceiptIcon from '@mui/icons-material/Receipt';
import { useSchemaForm, Form } from "@/components/form";
import { notify } from "@/shared/notification";
import { useEmisorConfig } from "@/features/facturacion-electronica/hooks/use-emisor-config";
import { useState } from "react";
import { timbradoConfigSchema } from "@/features/facturacion-electronica/components/timbrado-config-content";

export default function ConfiguracionFacturacionElectronicaPage() {
    const { config, saveConfig, isLoading } = useEmisorConfig();
    const [isSaving, setIsSaving] = useState(false);

    const form = useSchemaForm({
        schema: timbradoConfigSchema,
        defaultValues: {
            establecimiento: config?.establecimiento || "",
            puntoExpedicion: config?.puntoExpedicion || "",
        },
        onSubmit: async ({ value }) => {
            setIsSaving(true);
            try {
                saveConfig(value);
                notify("Configuración guardada correctamente");
            } catch (error) {
                notify("Error al guardar la configuración");
            } finally {
                setIsSaving(false);
            }
        }
    });

    if (isLoading) {
        return (
            <Container maxWidth="sm" component={Stack} flex={1} paddingY={3} alignItems="center" justifyContent="center">
                <CircularProgress />
            </Container>
        );
    }

    return (
        <Container maxWidth="sm" component={Stack} flex={1} paddingY={3} gap={3}>
            <Stack direction="row" alignItems="center" gap={1}>
                <ReceiptIcon color="primary" />
                <Typography variant="h5" component="h1">
                    Configuración de Facturación Electrónica
                </Typography>
            </Stack>

            <Alert severity="info">
                Esta configuración se guarda para esta computadora.
            </Alert>

            <Card>
                <CardContent>
                    <Form form={form} gap={3}>
                        <Stack gap={2}>
                            <Form.TextField
                                name="establecimiento"
                                label="Establecimiento *"
                                placeholder="001"
                                helperText="Código de 3 dígitos"
                                inputProps={{ maxLength: 3 }}
                                size="small"
                            />

                            <Form.TextField
                                name="puntoExpedicion"
                                label="Punto de Expedición *"
                                placeholder="001"
                                helperText="Código de 3 dígitos"
                                inputProps={{ maxLength: 3 }}
                                size="small"
                            />
                        </Stack>

                        <Form.SubmitButton
                            variant="contained"
                            disabled={isSaving}
                            fullWidth
                            sx={{ mt: 2 }}
                        >
                            {isSaving ? "Guardando..." : "Guardar Configuración"}
                        </Form.SubmitButton>
                    </Form>
                </CardContent>
            </Card>
        </Container>
    );
}
